import { render } from "./IngresoPreguntasSimce.vue?vue&type=template&id=5bbe7fba&scoped=true"
import script from "./IngresoPreguntasSimce.vue?vue&type=script&lang=js"
export * from "./IngresoPreguntasSimce.vue?vue&type=script&lang=js"

import "./IngresoPreguntasSimce.vue?vue&type=style&index=0&id=5bbe7fba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbe7fba"]])

export default __exports__